import { useMemo, forwardRef } from 'react'
import { Language } from '@material-ui/icons'
import { useAuth } from '@praxis/component-auth'
import { StyledListItemText, UseStyles } from '../StyledList'
import { ListItem, ListItemIcon } from '@material-ui/core'
import { arrayOf, string, func } from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'

export const NotificationButton = (props) => {
  const auth = useAuth()
  const { isAuthorized, isAuthenticated } = auth
  const classes = UseStyles()

  const { groups, text, to, onClose } = props
  const renderLink = useMemo(
    () =>
      forwardRef((itemProps, ref) => (
        <RouterLink
          underline="none"
          exact="true"
          to={to}
          ref={ref}
          {...itemProps}
        />
      )),
    [to],
  )

  if (isAuthenticated()) {
    if (isAuthorized(groups)) {
      return (
        <ListItem
          button
          onClick={onClose}
          component={renderLink}
          className={classes.nested}
        >
          <ListItemIcon>
            <Language />
          </ListItemIcon>
          <StyledListItemText primary={text} />
        </ListItem>
      )
    }
  }
  return null
}

NotificationButton.propTypes = {
  groups: arrayOf(string).isRequired,
  to: string.isRequired,
  text: string.isRequired,
  onClose: func.isRequired,
}
